module.exports = __webpack_public_path__ + "static/media/Bismillah.e0624613.png";